export default "__VITE_ASSET__6ddebd53__"